import template from './rate-hours-summary-report.html';
import controller from './rate-hours-summary-report.controller';

let rateHoursSummaryReportComponent = {
  restrict: 'E',
  template,
  controller
};

export default rateHoursSummaryReportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/rate-hours-summary-report/rate-hours-summary-report.component.js